import { render, staticRenderFns } from "./MobileHeaderMenu.vue?vue&type=template&id=5d4f3358&scoped=true&"
import script from "./MobileHeaderMenu.vue?vue&type=script&lang=ts&"
export * from "./MobileHeaderMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MobileHeaderMenu.vue?vue&type=style&index=0&id=5d4f3358&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4f3358",
  null
  
)

export default component.exports